import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import CountUp from "react-countup";
import "react-modal-video/css/modal-video.css";

function AchivementTwo() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <div className="achievment-section2">
        <div className="container">
          <div className="row d-flex align-items-center g-4">
            <div className="col-lg-4 col-md-5 col-sm-6">
              <div className="achv-vdo2">
                <img
                  src={process.env.PUBLIC_URL + "/images/bg/ach-vdo2.png"}
                  alt="images"
                />
                <div className="video-play">
                  <div
                    onClick={() => setOpen(true)}
                    className="video-open video-icon"
                  >
                    <i className="bx bx-play" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-7 col-sm-6">

              <div className="quote-text ms-auto">
                <h4 className="cusm-front" style={{color:"white"}}>OUR ACHIEVEMENTS </h4>
                <p  className="cusm-front" style={{color:"white"}}>
                At Genius Fixers, we take great pride in our achievements and are constantly striving to improve and innovate in the technology industry. Here are some of our most notable accomplishments: 

 
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-7 col-sm-6">
              <div className="quote-text ms-auto">
                <h4  className="cusm-front" style={{color:"white"}}>Client Satisfaction: </h4>
                <p  className="cusm-front" style={{color:"white"}}>
                We have a proven track record of delivering high-quality software solutions that meet and exceed our clients' expectations. Our focus on client satisfaction has earned us a reputation as a trusted technology partner, and we take great pride in our long-term relationships with our clients.

 
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-7 col-sm-6">
              <div className="quote-text ms-auto">
                <h4  className="cusm-front" style={{color:"white"}}>Innovation</h4>
                <p  className="cusm-front" style={{color:"white"}}>
                We are always looking for new and innovative ways to solve complex business problems using technology. Our team of experts stays up to date with the latest advancements in technology to ensure that our clients receive the most innovative and effective solutions. 
 
                </p>
              </div>
            </div>


            <div className="col-lg-6 col-md-7 col-sm-6">
              <div className="quote-text ms-auto">
                <h4  className="cusm-front" style={{color:"white"}}>Community Involvement</h4>
                <p  className="cusm-front" style={{color:"white"}}>
                We are committed to giving back to the community and have supported a range of charitable initiatives over the years. Our team members regularly volunteer their time and expertise to help non-profit organizations and community initiatives. 
                </p >
              </div>
            </div>


            <div className="col-lg-6 col-md-7 col-sm-6">
              <div className="quote-text ms-auto">
                <h4  className="cusm-front" style={{color:"white"}}>Industry Recognition:</h4>
                <p  className="cusm-front" style={{color:"white"}}>
                Our achievements have not gone unnoticed in the technology industry. We have been recognized with several awards and accolades, including being named one of the top IT consulting firms by Clutch, a leading B2B ratings, and reviews platform. 
                </p>
              </div>
            </div>
            <div className="col-lg-9 col-md-7 col-sm-6">
              <div className="quote-text ms-auto">
              
                <p  className="cusm-front" style={{color:"white"}}> 
                At Genius Fixers, we are committed to achieving excellence in everything we do. We will continue to push the boundaries of technology and deliver exceptional solutions to our clients while maintaining our commitment to innovation, talent development, community involvement, and industry recognition.
                </p>
              </div>
            </div>

          </div>
          
        </div>
      </div>
      <div className="counter2-section">
        <div className="container">
          <div className="row">
            <div className="counter2-wrapper d-flex justify-content-lg-between justify-content-center flex-wrap gap-4">
              <div className="single-counter">
                <div className="counter-icon">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/ach24.svg"}
                    alt="images"
                  />
                </div>
                <div className="counter-text hometwo counter-item">
                  <h3 data-odometer-final={40}>
                    <CountUp
                      className="odometer"
                      end={10}
                      delay={2}
                      duration={5}
                    />
                  </h3>
                  <p>Years of Experience </p>
                </div>
              </div>
              <div className="single-counter">
                <div className="counter-icon">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/ach23.svg"}
                    alt="images"
                  />
                </div>
                <div className="counter-text hometwo counter-item">
                  <h3 className="odometer" data-odometer-final={150}>
                    <CountUp
                      className="odometer"
                      end={100}
                      delay={2}
                      duration={5}
                    />
                  </h3>
                  <p>Happy Clients </p>
                </div>
              </div>
              <div className="single-counter">
                <div className="counter-icon">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/ach22.svg"}
                    alt="images"
                  />
                </div>
                <div className="counter-text hometwo counter-item">
                  <h3 className="odometer" data-odometer-final={520}>
                    <CountUp
                      className="odometer"
                      end={250}
                      delay={2}
                      duration={5}
                    />
                  </h3>
                  <p>Finished Projects </p>
                </div>
              </div>
              <div className="single-counter">
                <div className="counter-icon">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/ach21.svg"}
                    alt="images"
                  />
                </div>
                <div className="counter-text hometwo counter-item">
                  <h3 className="odometer" data-odometer-final={40}>
                    <CountUp
                      className="odometer"
                      end={5}
                      delay={2}
                      duration={5}
                    />
                  </h3>
                  <p>Our Awards</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <React.Fragment>
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId="L61p2uyiMSo"
          onClose={() => setOpen(false)}
        />
      </React.Fragment>
    </>
  );
}

export default AchivementTwo;
